import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { scaffolderPageOverride } from './ScaffolderPageOverride';
import { scaffolderTemplatesOverride } from './ScaffolderTemplatesOverride';
import { DependentFieldPickerExtension } from './dependentFieldPicker';
import {
  ComponentResourcePickerExtension,
  GroupResourcePickerExtension,
} from './resourcePicker';
import { SubgroupPickerExtension } from './subgroupPicker';
import { MigrationTeamPickerExtension } from './migrationTeamPicker';
import { MigrationServicePickerExtension } from './migrationServicePicker';
import { MigrationServiceTableExtension } from './migrationServiceTable';
import { ConjurSecretListFieldExtension } from './conjurSecretList';
import { TeamAwareClusterPickerExtension } from './teamAwareClusterPicker';
import { DependentEntityPickerExtension } from './dependentEntityPicker/extensions';
import { DependentEnvBranchInputExtension } from './dependentEnvBranchInput/extensions';

export const scaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    scaffolderPageOverride,
    scaffolderTemplatesOverride,
    DependentFieldPickerExtension,
    ComponentResourcePickerExtension,
    GroupResourcePickerExtension,
    SubgroupPickerExtension,
    MigrationTeamPickerExtension,
    MigrationServicePickerExtension,
    MigrationServiceTableExtension,
    TeamAwareClusterPickerExtension,
    ConjurSecretListFieldExtension,
    DependentEnvBranchInputExtension,
    DependentEntityPickerExtension,
  ],
});
